<template>
  <!--Evento emitido ao digitar algo no input 
    @event input
    @param {String} value - Valor digitado no input
-->
  <v-textarea
    v-bind="$attrs"
    outlined
    persistent-hint
    class="zoox-component zoox-input-area"
    :hint="hint"
    :label="label"
    :value="value"
    :rules="rules"
    :readonly="readonly"
    :disabled="disabled"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :hide-details="hideDetails"
    :maxlength="maxLength"
    :counter="counter"
    :clearable="clearable"
    :rows="rows"
    :no-resize="noResize"
    @input="$emit('input', $event)"
  >
    <!--@slot Slot padrão do componente -->
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
  </v-textarea>
</template>

<script>
import inputMixins from '../inputControlPropsMixin'

/**
 * @displayName Input Area
 */
export default {
  name: 'ZInputArea',
  mixins: [inputMixins],
  props: {
    /**
     * Número de linhas do input area
     */
    rows: {
      type: Number,
    },
    /**
     * Adiciona funcionalidade de "limpar" o input
     */
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Número máximo de caracteres
     */
    maxLength: {
      type: Number,
      default: Infinity,
    },
    /**
     * Flag para indicar que o text-area não deve
     * conter
     */
    noResize: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para colocar um contador de caracteres
     */
    counter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<style lang="scss">
.zoox-input-area:not(.error--text) {
  .v-input__slot:hover {
    fieldset {
      color: var(--primary) !important;
    }
  }
}
</style>
